import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
`;

export const Button = styled.button`
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 10px;
  margin-top: 20px;
`;

export const ListHolder = styled.div`
  margin: auto;
  padding-left: 21px;
  @media ${({ theme }) => theme.queries.minTablet} {
    width: 90%;
  }
  @media ${({ theme }) => theme.queries.minDesktop} {
    width: 70%;
  }
`;

export const List = styled.ol`
  text-align: left;
  list-style: decimal;
`;

export const Link = styled.a`
  text-decoration: underline;
`;
